import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import styled from 'styled-components';

import firebase from "./firebase/firebase";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

import backgroundPic from "./images/headphones.jpg";
import CII from "./images/cii.jpg";
import Con from "./images/conun.jpg";
import Footer from "./Footer"
import { Paper } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  title: {
    flexGrow: 1,
    textAlign: 'start',
    color:"#FFF"
  },
  appBar:{
    background:"transparent",
  },
  myTabs:{
    textAlign:"end",
    padding:20,
  
  },
  tabButns:{
    border:"transparent",
    color:"#FFF"
  },
  headerBackground:{
    background: `url(${backgroundPic}) no-repeat`,
    backgroundSize: "cover",

  },
  textOnSlideShow:{
    textAlign:"center",
    width:"80%",
    color:"#FFF",
    alignContent:"center",
    alignItems:"center",
    
  },
  blocks: {
    margin: 10,
    //display: "inline-block",
    alignItems: "center",
    alignContent: "center",
  
    
  },
  songprev: {
    height: "150px",
    width: "150px",
    
  },
  songDetails: {
    textAlign:"start",
    fontSize: 14,
  }
 
}));

const StyledButton = styled.button`
color: white;
	padding: 5px;
	border: 1px;
	background: none;
  font-size: 1em;
  margin: 5px 10px 0px;

	&:hover {
		background: none;
    color: purple;
    cursor:pointer;
	}
`;

function Music() {
  const classes = useStyles();

  const [songs, setSongs] = useState([]);

  useEffect(() => {
    getSongs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getSongs = () => {
    var allSongs = [];
    firebase
      .firestore()
      .collection("DownloadUrls")
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          if (doc.exists) {
            allSongs.push(doc.data());
            var re = Object.values(allSongs);
            setSongs(re);
          }
        });
      })
      .catch(err => {
        console.log("error", err);
      });
  };

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={12} className={classes.headerBackground}>
        <AppBar position="static" className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            K-BRIELLY MUSIC
          </Typography>
        </Toolbar>
      </AppBar>
      <div className={classes.myTabs}>
        <StyledButton
        onClick={()=>{
          window.location.href="/"
        }}
          onMouseEnter={()=>{
            console.log("color")
          }}>
          HOME
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/stream"
        }}
        >
          STREAM
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/music"
        }}
        >
          MUSIC
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/videos"
        }}
        >
          VIDEOS
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/contacts"
        }}
        >
          CONTACT
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/about"
        }}
        >
          ABOUT
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/"
        }}
        >
          BLOG
        </StyledButton>
      </div>
      <hr></hr>
      </Grid>
      
        <Grid container justify="center">
        <Grid item xs={12} md={8} style={{background:"black",padding:20}}>
         <Paper style={{background:"#ccccb3",color:"#FFF"}}>
         <Typography style={{textAlign:"start", padding:10,marginLeft:10}}>
             K-Brielly Songs
           </Typography>
           <Grid container justify="center" >
            {songs.map(item => (
              <Grid item  className={classes.blocks} key={item.Url}>
                <Paper elevation={20} className={classes.songprev} style={{
                      background:`url(${item.Url}) no-repeat`,
                      backgroundSize:"cover"
                    }}>
                  <StyledButton
                      variant="outlined"
                      onClick={() => {
                        window.open(item.Song);
                      }}
                    >
                      Download
                    </StyledButton>
                </Paper>
                <Grid item xs={12} className={classes.songDetails}>
                    <span>
                      {item.Artist} <br/>
                      {item.SongName}
                    </span>
                  </Grid>
              </Grid>
            ))}
          </Grid>
         </Paper>
         </Grid>
         <Grid item  xs={12} md={4} style={{background:"black",padding:20}}>
         <Paper>
           <Typography style={{textAlign:"start", padding:10,marginLeft:10}}>
             K-Brielly Albums On Sale
           </Typography>
           <Grid container justify="center" >
           <Grid item  className={classes.blocks} >
                <Paper elevation={20} className={classes.songprev} style={{
                      background:`url(${Con}) no-repeat`,
                      backgroundSize:"cover"
                    }}>
                  <StyledButton
                      style={{ marginTop:50,background:"Black"}}
                      variant="outlined"
                      onClick={() => {
                        window.open("https://music.apple.com/us/album/conundrum/1466566642");
                      }}
                    >
                      BUY NOW
                    </StyledButton>
                </Paper>
                <Grid item xs={12} className={classes.songDetails}>
                    <span>
                      K-Brielly <br/>
                      Conundrum 
                    </span>
                  </Grid>
              </Grid>
              <Grid item  className={classes.blocks} >
                <Paper elevation={20} className={classes.songprev} style={{
                      background:`url(${CII}) no-repeat`,
                      backgroundSize:"cover"
                    }}>
                  <StyledButton
                      style={{ marginTop:50,background:"Black"}}
                      variant="outlined"
                      onClick={() => {
                        window.open("https://music.apple.com/us/album/conundrum-ii/1501259443");
                      }}
                    >
                      BUY NOW
                    </StyledButton>
                </Paper>
                <Grid item xs={12} className={classes.songDetails}>
                    <span>
                      K-Brielly <br/>
                      Conundrum II
                    </span>
                  </Grid>
              </Grid>
           </Grid>
         </Paper>
         </Grid>
        </Grid>
        </Grid>
        <Grid item xs={12} >
          <Footer/>
        </Grid>
    </div> 
  );
}

export default Music;
